import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { URLS } from '../../resources/constants';
import './forecast.css';

export type ForecastPage = 'list' | 'entry' | 'executive_dashboard' | 'five_year_view' | 'monthly_view'
    | 'income_detail' | 'cogs_detail' | 'expense_detail' | 'payroll' | 'cash_flow' | 'balance_sheet';

interface Props {
    active: ForecastPage;
    forecastId?: number;
    children: React.ReactNode;
}

// Pages of one forecast (enabled once a forecast is open).
const FORECAST_PAGES: { key: ForecastPage; label: string; url: string }[] = [
    { key: 'entry', label: 'Forecast Entry', url: URLS.FIVE_YEAR_FORECAST_ENTRY },
    { key: 'executive_dashboard', label: 'Executive Dashboard', url: URLS.FIVE_YEAR_FORECAST_DASHBOARD },
    { key: 'five_year_view', label: 'Five-Year View', url: URLS.FIVE_YEAR_FORECAST_FIVE_YEAR_VIEW },
    { key: 'monthly_view', label: 'Monthly View', url: URLS.FIVE_YEAR_FORECAST_MONTHLY_VIEW },
    { key: 'income_detail', label: 'Income Detail', url: URLS.FIVE_YEAR_FORECAST_INCOME_DETAIL },
    { key: 'cogs_detail', label: 'COGS Detail', url: URLS.FIVE_YEAR_FORECAST_COGS_DETAIL },
    { key: 'expense_detail', label: 'Expense Detail', url: URLS.FIVE_YEAR_FORECAST_EXPENSE_DETAIL },
    { key: 'payroll', label: 'People & Payroll', url: URLS.FIVE_YEAR_FORECAST_PAYROLL },
    { key: 'cash_flow', label: 'Cash Flow', url: URLS.FIVE_YEAR_FORECAST_CASH_FLOW },
    { key: 'balance_sheet', label: 'Balance Sheet', url: URLS.FIVE_YEAR_FORECAST_BALANCE_SHEET },
];

/** Five-Year Forecast module shell: navy left navigation + main content. */
const ForecastLayout: React.FC<Props> = ({ active, forecastId, children }) => {
    const { t } = useTranslation('scenes.FiveYearForecast');
    const navigate = useNavigate();

    return (
        <div className="fyf">
            <nav className="fyf-nav">
                <div className="fyf-brand">
                    <span className="rev">REV</span>REX
                    <small>{t('nav.brand', 'FIVE YEAR FORECAST')}</small>
                </div>
                <button type="button" className={active === 'list' ? 'active' : ''}
                    onClick={() => navigate(URLS.FIVE_YEAR_FORECAST)}>
                    {t('nav.forecasts', 'My Forecasts')}
                </button>
                {FORECAST_PAGES.map((p) => {
                    const enabled = !!forecastId;
                    return (
                        <button key={p.key} type="button" disabled={!enabled}
                            className={active === p.key ? 'active' : ''}
                            onClick={() => enabled && navigate(p.url.replace(':forecastId', String(forecastId)))}>
                            {t(`nav.${p.key}`, p.label)}
                        </button>
                    );
                })}
            </nav>
            <main className="fyf-main">
                {children}
                <div className="fyf-footer">{t('nav.footer', 'REVREX Five Year Forecast')}</div>
            </main>
        </div>
    );
};

export default ForecastLayout;
